import { SVG } from '../svg';
import { IconProps } from '../types';

export function CheckCircleIcon(props: IconProps): JSX.Element {
  return (
    <SVG {...props}>
      <circle cx="12" cy="12" r="10" />
      <path d="m9 12 2 2 4-4" />
    </SVG>
  );
}
